import httpClientNotifications from '../api/httpClientNotifications';

export const sendPushNotification = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/Send', payload);
  return response.data;
};

export const sendPushNotificationToAll = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToAll/to-all', payload);
  return response.data;
};

export const sendPushNotificationToMember = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToMember/to-member', payload);
  return response.data;
};

export const sendPushNotificationToMembers = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToMembers/to-members', payload);
  return response.data;
};

export const sendPushNotificationToGroup = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToGroup/to-group', payload);
  return response.data;
};

export const sendPushNotificationToGroups = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToGroups/to-groups', payload);
  return response.data;
};

export const sendPushNotificationToDevice = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/SendToDevice/to-device', payload);
  return response.data;
};

export const testDeviceToken = async (payload) => {
  const response = await httpClientNotifications.post('/api/notifications/PushNotification/TestDeviceToken/test-device-token', payload);
  return response.data;
};

export const getPushNotificationRecords = async ({ pageNumber = 1, pageSize = 10 } = {}) => {
  const response = await httpClientNotifications.get('/api/notifications/PushNotification/GetRecords', {
    params: { pageNumber, pageSize },
  });
  return response.data;
};

export const getPushNotificationRecordById = async (id) => {
  const response = await httpClientNotifications.get(`/api/notifications/PushNotification/GetRecordById/${id}`);
  return response.data;
};

export default {
  sendPushNotification,
  sendPushNotificationToAll,
  sendPushNotificationToMember,
  sendPushNotificationToMembers,
  sendPushNotificationToGroup,
  sendPushNotificationToGroups,
  sendPushNotificationToDevice,
  testDeviceToken,
  getPushNotificationRecords,
  getPushNotificationRecordById,
};

